import keycloakAxios from '@/services/axios';

export const getAllEmployees = async (companyId?: string) => {
  let endpoint = 'company/employees';

  if (companyId) {
    endpoint = `company/${companyId}/employees`;
  }

  const response = await keycloakAxios.get(endpoint);

  if (response.status >= 300) {
    throw new Error(
      `Error finding employees: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
